import { Card, Col, Row } from "antd";

import { GET } from "../../../providers/useAxiosQuery";
import {
	checkPermissions,
	setFileStorage,
} from "../../../providers/useCapacitorStorage";

export default function PageDashboard() {
	GET(
		`api/profile_faculty_load_schedule?from=FacultyMonitoringAttendance&roles=3,4,5`,
		"profile_list",
		(res) => {
			if (res && res.data) {
				let data = res.data.map((faculty) => ({
					value: faculty.id,
					label: `(${faculty.school_id}) ${faculty.fullname}`,
				}));

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "profile_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		`api/faculty_load_schedule?from=page_monitoring`,
		"faculty_load_schedule_list",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "faculty_load_schedule_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		"api/school_year?sort_field=id&sort_order=asc",
		"school_year_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "school_year_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		"api/semester?sort_field=id&sort_order=asc",
		"semester_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "semester_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		"api/day_schedule?sort_field=id&sort_order=asc",
		"day_schedule_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "day_schedule_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		"api/building",
		"building_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "building_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		`api/floor`,
		"floor_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "floor_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		`api/room`,
		"room_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "room_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	GET(
		`api/status?status_category_code=SC-01&from=PageFacultyLoadMonitoring`,
		"status_select",
		(res) => {
			if (res && res.data) {
				let data = res.data;

				checkPermissions().then((res1) => {
					if (res1) {
						if (res1.publicStorage === "granted") {
							setFileStorage({
								foldername: "faculty_load_attendance",
								filename: "status_list",
								data,
								override: true,
							});
						}
					}
				});
			}
		},
		false
	);

	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={8} lg={8} xl={8}>
				<Card title="Pending Upload" bordered={false}>
					<p>0</p>
				</Card>
			</Col>

			<Col xs={24} sm={24} md={8} lg={8} xl={8}>
				<Card title="Uploaded" bordered={false}>
					<p>0</p>
				</Card>
			</Col>

			<Col xs={24} sm={24} md={8} lg={8} xl={8}>
				<Card title="Total Faculty" bordered={false}>
					<p>0</p>
				</Card>
			</Col>
		</Row>
	);
}
